module.exports = __webpack_public_path__ + "static/media/user-nurse.27ea01dc.svg";